export const FETCH_SETTINGS = 'FETCH_SETTINGS';
